import { ResponsesConnectionError } from '@consta/uikit/ResponsesConnectionError'
import { ResponsesEmptyBox } from '@consta/uikit/ResponsesEmptyBox'
import { ResponsesNothingFound } from '@consta/uikit/ResponsesNothingFound'

import { createResponse } from './createResponse'

export const NothingFound = createResponse(ResponsesNothingFound)
export const LoadingFailed = createResponse(ResponsesConnectionError)
export const EmptyForNow = createResponse(ResponsesEmptyBox)
